"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHint = exports.FormLabel = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../icons");
var style_1 = require("../../style");
var variables_1 = require("../../style/variables");
var layout_1 = require("../layout");
var Text_1 = __importDefault(require("../Text"));
var Tooltip_1 = __importDefault(require("../Tooltip"));
var styles = {
    container: react_1.css({
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
    }),
};
var FormLabel = function (_a) {
    var children = _a.children, textBodyProps = __rest(_a, ["children"]);
    return (react_1.jsx(Text_1.default.Body, __assign({ color: style_1.DesignSystemColor.Gray.DARK_2, css: {
            fontWeight: 500,
        } }, textBodyProps), children));
};
exports.FormLabel = FormLabel;
var FormHint = function (_a) {
    var children = _a.children, textBodyProps = __rest(_a, ["children"]);
    return (react_1.jsx(Text_1.default.Body, __assign({ size: "sm" }, textBodyProps), children));
};
exports.FormHint = FormHint;
var InputLabel = function (props) {
    var label = props.label, hint = props.hint, infoText = props.infoText, _a = props.error, error = _a === void 0 ? false : _a, children = props.children;
    return (react_1.jsx("label", { css: styles.container },
        label ? (react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 4 },
            react_1.jsx(exports.FormLabel, null, label),
            infoText ? (react_1.jsx(Tooltip_1.default, { overlay: infoText },
                react_1.jsx(icons_1.InfoCircle, { size: 16, color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")" }))) : null)) : null,
        children,
        hint ? (react_1.jsx(exports.FormHint, { color: error ? style_1.DesignSystemThemeColor.Error.DEFAULT : style_1.DesignSystemColor.Gray.DEFAULT }, hint)) : null));
};
exports.default = InputLabel;
